import { Link } from "react-router";
import type { Studio } from "@/lib/api/schemas";
import { mediaUrl } from "@/lib/env";
import { serviceImagePath } from "@/lib/media";

/**
 * Service directions as round "highlights", like the studio's Instagram profile:
 * a photo in a crimson-to-gold ring, the category below. Opens the catalogue on it.
 */
export function Highlights({ studio, label }: { studio: Studio; label: string }) {
  const categories = [...new Set(studio.services.map((s) => s.category).filter(Boolean))];
  if (categories.length < 2) return null;
  return (
    <nav aria-label={label} className="w-full">
      <ul className="highlights list-none">
        {categories.map((c) => {
          const img = mediaUrl(
            studio.services.filter((s) => s.category === c).map((s) => serviceImagePath(studio, s)).find(Boolean) ?? null,
          );
          return (
            <li key={c}>
              <Link to={`/s/${studio.slug}/services?c=${encodeURIComponent(c)}`} className="highlight">
                <span className="highlight-ring" aria-hidden="true">
                  {/* Eager: a few small thumbnails, and lazy loading inside this horizontal scroller never fired. */}
                  {img ? <img src={img} alt="" decoding="async" /> : <span className="highlight-initial">{c.charAt(0)}</span>}
                </span>
                <span className="highlight-label">{c}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
